import X from '../x.js';

class XMenuBar extends X {
  render(target) {
    target.innerHTML = `
      <style>
        slot {
          display: flex;
          align-items: center;
          border-radius: calc(36px + 0.4rem);
          padding: 0.4rem;
          background-color: rgba(255, 255, 255, 0.5);
        }

        ::slotted(button),
        ::slotted(a) {
          display: flex;
          justify-content: center;
          height: 36px;
          width: 36px;
          border-radius: 36px;
          display: flex;
          align-items: center;
          margin-right: 1rem !important;
          background-color: white;
          color: black;
          text-transform: uppercase;
        }

        ::slotted(button:last-child),
        ::slotted(a:last-child) {
          margin-right: 0 !important;
        }
      </style>

      <slot></slot>
    `;
  }
}

customElements.define('x-menu-bar', XMenuBar);
